import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Redirigir a los usuarios según su rol y la ruta actual
  if (user) {
    // Si es un vendedor y está intentando acceder al dashboard principal, redirigir al dashboard de vendedor
    if (user.role === 'seller' && location.pathname === '/dashboard') {
      return <Navigate to="/seller-dashboard" />;
    }
    
    // Si es un supervisor y está intentando acceder al dashboard principal, redirigir al dashboard de supervisor
    if (user.role === 'manager' && location.pathname === '/dashboard') {
      return <Navigate to="/supervisor-dashboard" />;
    }
    
    // Si es un admin o master y está intentando acceder al dashboard de vendedor, redirigir al dashboard principal
    if ((user.role === 'admin' || user.role === 'master') && location.pathname === '/seller-dashboard') {
      return <Navigate to="/dashboard" />;
    }
    
    // Permitir que admin acceda al dashboard de supervisor (Vista Supervisor)
    // Solo master no puede acceder al dashboard de supervisor
    if (user.role === 'master' && location.pathname === '/supervisor-dashboard') {
      return <Navigate to="/dashboard" />;
    }
    
    // Si es un vendedor y está intentando acceder al dashboard de supervisor, redirigir al dashboard de vendedor
    if (user.role === 'seller' && location.pathname === '/supervisor-dashboard') {
      return <Navigate to="/seller-dashboard" />;
    }
  }

  // Render children if authenticated and role matches the route
  return children;
};

export default ProtectedRoute;
